@if (totalPages > 0) {
  <div class="d-flex flex-wrap align-items-center justify-content-between mt-2 mb-1">
    <!-- Navegação -->
    <div class="d-flex align-items-center flex-wrap">
      <button class="btn btn-sm btn-outline-secondary mr-1" [disabled]="page === 1" (click)="first()" title="Primeira página">
        &laquo; Início
      </button>
      <button class="btn btn-sm btn-outline-secondary mr-1" [disabled]="page === 1" (click)="prev()" title="Página anterior">
        &lsaquo; Anterior
      </button>
      @for (p of pages; track p) {
        <button class="btn btn-sm mr-1"
          [class.btn-secondary]="p === page"
          [class.btn-outline-secondary]="p !== page"
          (click)="goTo(p)">
          {{ p }}
        </button>
      }
      <button class="btn btn-sm btn-outline-secondary ml-1" [disabled]="page === totalPages" (click)="next()" title="Próxima página">
        Próximo &rsaquo;
      </button>
      <button class="btn btn-sm btn-outline-secondary ml-1" [disabled]="page === totalPages" (click)="last()" title="Última página">
        Fim &raquo;
      </button>
    </div>
    <!-- Info + PageSize -->
    <div class="d-flex align-items-center mt-1">
      <small class="text-secondary mr-2">
        Página <b>{{ page }}</b> de <b>{{ totalPages }}</b> &mdash; Total: <b>{{ totalItems }}</b>
      </small>
      <label class="text-secondary mb-0 mr-1"><small>Itens/pág:</small></label>
      <select class="form-control form-control-sm" style="width: auto;"
        [value]="pageSize"
        (change)="onPageSizeChange($event.target.value)">
        @for (s of pageSizes; track s) {
          <option [value]="s">{{ s }}</option>
        }
      </select>
    </div>
  </div>
}
